import React, { useEffect } from "react";
import { FUTURES_LEVERAGE_REJECTION_MSG } from "./futuresLeverageHelpers";

/**
 * Leverage / quantity rejection popup — existing agce-margin-lvg modal shell, single Cancel button.
 */
export default function FuturesOrderRejectionModal({ open, onClose, message = FUTURES_LEVERAGE_REJECTION_MSG }) {
    useEffect(() => {
        if (!open) return;
        const onKey = (e) => {
            if (e.key === "Escape") onClose?.();
        };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="agce-margin-lvg-modal-root" role="presentation">
            <div className="agce-margin-lvg-modal-backdrop" onClick={onClose} aria-hidden />
            <div
                className="agce-margin-lvg-modal-panel"
                role="dialog"
                aria-modal="true"
                aria-labelledby="agce-ft-order-reject-title"
                onClick={(e) => e.stopPropagation()}
                style={{ maxWidth: 420 }}
            >
                <div className="agce-margin-lvg-modal-head">
                    <h2 id="agce-ft-order-reject-title" className="agce-margin-lvg-modal-title">
                        Order rejected
                    </h2>
                    <button type="button" className="agce-margin-lvg-modal-close" onClick={onClose} aria-label="Close">
                        <i className="ri-close-line ri-lg" aria-hidden />
                    </button>
                </div>
                <div className="agce-margin-lvg-modal-body">
                    <p className="agce-margin-lvg-warn">{message}</p>
                </div>
                <div className="agce-margin-lvg-modal-foot">
                    <button type="button" className="agce-margin-lvg-btn agce-margin-lvg-btn--ghost" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}
